import { TaskBase } from "@calaosoft/osapp-mobile/modules/bts/models/task-base";
import { TaskDescriptor } from "@calaosoft/osapp-mobile/modules/bts/models/task-descriptor";
import { StockService } from "@calaosoft/osapp-mobile/modules/logistics/stock/services/stock.service";
import { defer, Observable, of } from "rxjs";
import { IStockUpdateTaskParams } from "./istock-update-task-params";

/** Mets à jour tous les stocks. */
export class StockUpdateTask<T extends IStockUpdateTaskParams> extends TaskBase<T> {
	//#region FIELDS

	private readonly msvcStock: StockService;

	//#endregion FIELDS

	//#region METHODS

	constructor(poDescriptor: TaskDescriptor<T>) {
		super(poDescriptor);

		this.msvcStock = poDescriptor.ioInjector.get(StockService);
	}

	/** @override */
	protected override execTask$(): Observable<void> {
		return defer(() => this.msvcStock.updateAllStocksAsync() ?? of(undefined));
	}

	//#endregion METHODS
}
